// extracted by mini-css-extract-plugin
export default {"stepperWrapper":"Stepper_stepperWrapper__KW-D6","stepList":"Stepper_stepList__38KYP","active":"Stepper_active__DSVYB","completed":"Stepper_completed__VEq-k"};